import { useState, useContext } from "react";
import {
  useToast,
  Box,
  Text,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  InputGroup,
  InputLeftElement,
  Input,
  Spinner,
  InputRightElement,
} from "@chakra-ui/react";
import { EmailIcon, LockIcon, ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { AccountContext } from "../../context/AccountContext";
import { useNavigate } from "react-router-dom";

const ResetPassword = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [currPassword, setCurrPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const { logout, changePassword, getSession } = useContext(AccountContext);
  const toast = useToast();
  const navigate = useNavigate();
  const [showCurrPwd, setShowCurrPwd] = useState(false);
  const handleShowCurrPwd = () => setShowCurrPwd(!showCurrPwd);
  const [showOldPwd, setShowOldPwd] = useState(false);
  const handleShowOldPwd = () => setShowOldPwd(!showOldPwd);

  const changePasswordHandler = async () => {
    if (errorText) {
      setErrorText("");
    }
    try {
      setIsLoading(true);
      const session = await getSession();
      if (session.user) {
        const response = await changePassword(
          session.user,
          currPassword,
          newPassword
        );
        console.log(response);
        onClose();
        toast({
          title: "Password Changed",
          description: "Please sign in with your new password",
          status: "success",
          duration: 5000,
          isClosable: true,
          variant: "left-accent",
          position: "top",
        });
        logout();
        navigate("/");
      }
    } catch (error) {
      setErrorText(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <ModalContent>
        <ModalHeader>Change Password?</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box>
            <form>
              <FormControl>
                <InputGroup mt={2} mb={2}>
                  <InputLeftElement
                    pointerEvents="none"
                    children={<EmailIcon />}
                    color="gray"
                  />
                  <Input
                    autoFocus
                    type="email"
                    placeholder="Enter Email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                </InputGroup>
              </FormControl>
              <FormControl>
                <InputGroup mt={2} mb={2}>
                  <InputLeftElement
                    pointerEvents="none"
                    children={<LockIcon />}
                    color="gray"
                  />

                  <Input
                    type={showCurrPwd ? "text" : "password"}
                    placeholder="Enter Current Password"
                    value={currPassword}
                    onChange={(event) => setCurrPassword(event.target.value)}
                  />
                  <InputRightElement
                    children={
                      showCurrPwd ? (
                        <ViewIcon color="gray" onClick={handleShowCurrPwd} />
                      ) : (
                        <ViewOffIcon color="gray" onClick={handleShowCurrPwd} />
                      )
                    }
                  />
                </InputGroup>
              </FormControl>

              <FormControl>
                <InputGroup mt={2} mb={2}>
                  <InputLeftElement
                    pointerEvents="none"
                    children={<LockIcon />}
                    color="gray"
                  />

                  <Input
                    type={showOldPwd ? "text" : "password"}
                    placeholder="Enter New Password"
                    value={newPassword}
                    onChange={(event) => setNewPassword(event.target.value)}
                  />
                  <InputRightElement
                    children={
                      showOldPwd ? (
                        <ViewIcon color="gray" onClick={handleShowOldPwd} />
                      ) : (
                        <ViewOffIcon color="gray" onClick={handleShowOldPwd} />
                      )
                    }
                  />
                </InputGroup>
              </FormControl>

              <Text fontSize="xs" color="red">
                {errorText}
              </Text>
            </form>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Button
            mt={2}
            type="submit"
            size="sm"
            colorScheme="blue"
            onClick={changePasswordHandler}
            disabled={isLoading || !currPassword || !newPassword}
          >
            {isLoading ? <Spinner size="sm" mr={2} /> : null}
            Submit
          </Button>
        </ModalFooter>
      </ModalContent>
    </>
  );
};

export default ResetPassword;
